import { type ComponentStyleConfig } from "@chakra-ui/theme";
import { remCalc } from "theme/utils";
import { Input as inputTheme } from "./input";

export const Textarea: ComponentStyleConfig = {
  baseStyle: {
    // @ts-expect-error - The key exists in the input theme
    ...inputTheme.baseStyle?.field,
    minH: remCalc(44),
    // We need to explicitly set the padding to override Chakra's defaults
    py: "smaller",
    pr: "smaller",
    pl: "smaller",
  },
  sizes: {
    md: {
      // @ts-expect-error - The key exists in the input theme
      ...inputTheme.sizes?.md?.field,
    },
  },
  variants: {
    outline: {
      // @ts-expect-error - The key exists in the input theme
      ...inputTheme.variants?.outline?.field,
    },
  },
  defaultProps: {
    size: "md",
  },
};
